webpackJsonp([46355575822879],{

/***/ 364:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Church Services | Killasser Parish","author":"Kingluddite"}},"contentfulEucharist":{"title":"Eucharist","slug":"eucharist","metaDescription":"Killasser Parish Church Information on Eucharist","headerBackgroundImage":{"file":{"url":"//images.ctfassets.net/6rnd0h65xc7e/6NHL5TRbc4S0iOQGg8AkcS/6c2c78e4e7eb5a2a506867db4ce0e348/art-cathedral-christ-cropped.jpg"}},"sectionFourHeading":"Eucharist Info","sectionFourContent":{"childMarkdownRemark":{"html":"<p>Eucharist Placeholder</p>"}}}},"pathContext":{"slug":"/eucharist/","langKey":"en-US"}}

/***/ })

});


// WEBPACK FOOTER //
// path---eucharist-e5179f1ce4e949756ec0.js